module.exports = __webpack_public_path__ + "img/symbol_eco.7e08c43e.png";